import React from "react";

// A list of addresses under what is being typed: each is one property record, so the same address can be there more
// than once, told apart by its tags. Choosing one is the caller's.

const TAGS = [
  { key: "isSettled", label: "Settled", tone: "bg-yellow-100 text-yellow-800" },
  { key: "isMaster", label: "Master", tone: "bg-blue-100 text-blue-800" },
];

export default function AddressSuggestions({
  suggestions,
  highlighted,
  onHighlight,
  onPick,
}) {
  return (
    <ul
      role="listbox"
      aria-label="Addresses"
      className="absolute bottom-full left-3 right-3 z-10 mb-1 max-h-72 overflow-y-auto rounded-xl border border-mediumgray bg-white py-1 shadow-lg"
    >
      {suggestions.map((suggestion, index) => (
        <li
          key={suggestion.propertyId}
          role="option"
          aria-selected={index === highlighted}
          // Keeps the cursor in the message box.
          onMouseDown={(event) => event.preventDefault()}
          onMouseEnter={() => onHighlight(index)}
          onClick={() => onPick(suggestion)}
          className={`flex cursor-pointer items-center justify-between gap-3 px-3 py-2 text-sm text-darkergray ${index === highlighted ? "bg-lightgray" : ""}`}
        >
          <span className="min-w-0 truncate">{suggestion.address}</span>
          <span className="flex flex-none gap-1">
            {TAGS.filter((tag) => suggestion[tag.key]).map((tag) => (
              <span
                key={tag.key}
                className={`rounded px-1.5 py-0.5 text-2xs font-semibold ${tag.tone}`}
              >
                {tag.label}
              </span>
            ))}
          </span>
        </li>
      ))}
    </ul>
  );
}
